import {
  BsSearch,
  BsClipboardCheck,
  BsCodeSlash,
  BsGraphUpArrow,
} from "react-icons/bs";

function Process() {
  const process = [
    {
      icon: <BsSearch />,
      title: "Discovery",
      description: "Understanding your business, audience and objectives.",
    },
    {
      icon: <BsClipboardCheck />,
      title: "Strategy",
      description: "Creating a roadmap aligned with your growth goals.",
    },
    {
      icon: <BsCodeSlash />,
      title: "Execution",
      description: "Building, launching and implementing solutions.",
    },
    {
      icon: <BsGraphUpArrow />,
      title: "Growth",
      description: "Continuous improvement, support and optimization.",
    },
  ];

  return (
    <section className="process-section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">OUR PROCESS</span>

          <h2>How We Deliver Results</h2>

          <p>
            A structured process focused on quality, transparency and long-term
            growth.
          </p>
        </div>

        <div className="process-timeline">
          {process.map((step, index) => (
            <div className="timeline-item" key={index}>
              <div className="timeline-icon">{step.icon}</div>

              <h4>{step.title}</h4>

              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
